import { render, staticRenderFns } from "./UserNoteAdd.vue?vue&type=template&id=576ab506&scoped=true&"
import script from "./UserNoteAdd.vue?vue&type=script&lang=js&"
export * from "./UserNoteAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserNoteAdd.vue?vue&type=style&index=0&id=576ab506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ab506",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
